import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const Login = React.lazy(() => import("./Login"));

const routes = [{ path: "/*", element: Login }];

export default function Index() {
  return (
    <Suspense fallback={<></>}>
      <Routes>
        {routes.map((route, idx) => (
          <Route key={idx} path={route.path} element={<route.element />} />
        ))}
      </Routes>
    </Suspense>
  );
}
